<template>
  <div>
    <DataNavigation></DataNavigation>
    <VipPrompt :pageModal="page_modal" @pagecancel="pageCancel"></VipPrompt>
    <div class="index_content">
      <Layout>
        <Sider width="208">
          <div class="right_column">
            <p class="top-tip">公司</p>
            <div class="keyword-input">
              <Input search enter-button :placeholder="search_phd" v-model="search_ipt" @on-search="handleSearch" />
            </div>
            <div class="rigit_title">
              <span>筛选</span>
              <Dropdown trigger="click" placement="bottom-start" @on-visible-change="handleDropdown" @on-click="haddleScreenDropdown">
                <a href="javascript:void(0)">
                  <span>{{screen_active}}</span>
                  <Icon type="md-arrow-dropup" v-if="drop_val" />
                  <Icon type="md-arrow-dropdown" v-else />
                </a>
                <DropdownMenu slot="list">
                  <DropdownItem v-for="(item, sindex) in screen_dropdown" :name="item" :selected="screen_active == item" :key="sindex">{{item}}</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
            <div class="rigit_content">
              <div class="screen_ul">
                <div class="screen_li" v-show="screen_active === '全部' || screen_active === '公司领域'">
                  <div class="screen_tle" @click="screenTle.tag_arr = !screenTle.tag_arr">
                    <span>公司领域</span>
                    <Icon type="md-add" v-if="!screenTle.tag_arr" />
                    <Icon type="md-remove" v-else />
                  </div>
                  <div class="screen_cnt" v-show="screenTle.tag_arr">
                    <ul class="scr_attention">
                      <CheckboxGroup v-model="params.tag_arr" @on-change="handleChangeOption($event, 'tag_arr')">
                        <li v-for="tItem in dynview_tag_type" :key="tItem.id">
                          <div class="scr_att_tle">
                            <Icon type="md-arrow-dropright" v-if="!screen_sec[tItem.id]" @click="haddleSecSel(tItem.id)" />
                            <Icon type="md-arrow-dropdown" v-else @click="haddleSecSel(tItem.id)" />
                            <span @click="haddleSecSel(tItem.id)">{{tItem.name}}</span>
                          </div>
                          <div class="scr_att_cnt" v-show="screen_sec[tItem.id]">
                            <Checkbox v-for="item in hot_tag_map" :label="item.id" :key="item.id" v-if="item.type_id === tItem.id">
                              <span>{{item.name}} <template v-if="tagNum.length">({{item.id | dealName(tagNum, 'id', 'num', '0')}})</template></span>
                            </Checkbox>
                          </div>
                        </li>
                      </CheckboxGroup>
                    </ul>
                  </div>
                </div>
                <div class="screen_li" v-show="screen_active === '全部' || screen_active === '融资轮次'">
                  <div class="screen_tle" @click="screenTle.round_id = !screenTle.round_id">
                    <span>融资轮次</span>
                    <Icon type="md-add" v-if="!screenTle.round_id" />
                    <Icon type="md-remove" v-else />
                  </div>
                  <div class="screen_cnt" v-show="screenTle.round_id">
                    <Checkbox v-model="checkAll.round_id" class="all_option" :disabled="checkAll.round_id" @on-change="handleCheckAll('round_id')">
                      <span>不限</span>
                    </Checkbox>
                    <CheckboxGroup v-model="params.round_id" @on-change="handleChangeOption($event, 'round_id')">
                      <Checkbox v-for="(item,index) in round" :label="item.id" :key="index" v-show="index < 10 || showAllRound">
                        <span>{{item.name}} <template v-if="roundNum.length">({{item.id | dealName(roundNum, 'round_id', 'num', '0')}})</template></span>
                      </Checkbox>
                    </CheckboxGroup>
                    <span class="more_sel" @click="showAllRound = !showAllRound">
                      <template v-if="!showAllRound">查看更多</template>
                      <template v-else>收起更多</template>
                    </span>
                  </div>
                </div>
                <div class="screen_li" v-show="screen_active === '全部' || screen_active === '地区选择'">
                  <div class="screen_tle" @click="screenTle.address = !screenTle.address">
                    <span>地区选择</span>
                    <Icon type="md-add" v-if="!screenTle.address" />
                    <Icon type="md-remove" v-else />
                  </div>
                  <div class="screen_cnt" v-show="screenTle.address">
                    <RadioGroup v-model="params.demostic" vertical @on-change="handleChangeDemostic">
                      <Radio :label="null"><span>不限</span></Radio>
                      <Radio :label="0"><span>国外({{foreignNum}})</span></Radio>
                      <div class="sec_options" v-if="params.demostic == 0">
                        <Checkbox v-model="checkAll.address_id" class="all_option" :disabled="checkAll.address_id" @on-change="handleCheckAll('address_id')">
                          <span>全部</span>
                        </Checkbox>
                        <CheckboxGroup v-model="params.address_id" @on-change="handleChangeOption($event, 'address_id')">
                          <Checkbox v-for="(item,index) in foreign_country" :label="item.id" :key="index" v-show="index < 10 || showAllAddress">
                            <span>{{item.name}}</span>
                          </Checkbox>
                        </CheckboxGroup>
                        <span class="more_sel" @click="showAllAddress = !showAllAddress">
                          <template v-if="!showAllAddress">查看更多</template>
                          <template v-else>收起更多</template>
                        </span>
                      </div>
                      <Radio :label="1" class="bro"><span>国内({{chinaNum}})</span></Radio>
                      <div class="sec_options" v-if="params.demostic == 1">
                        <Checkbox v-model="checkAll.address_id" class="all_option" :disabled="checkAll.address_id" @on-change="handleCheckAll('address_id')">
                          <span>全部</span>
                        </Checkbox>
                        <CheckboxGroup v-model="params.address_id" @on-change="handleChangeOption($event, 'address_id')">
                          <Checkbox v-for="(item,index) in city" :label="item.id" :key="index" v-show="index < 10 || showAllAddress">
                            <span>{{item.name}}</span>
                          </Checkbox>
                        </CheckboxGroup>
                        <span class="more_sel" @click="showAllAddress = !showAllAddress">
                          <template v-if="!showAllAddress">查看更多</template>
                          <template v-else>收起更多</template>
                        </span>
                      </div>
                    </RadioGroup>
                  </div>
                </div>
                <div class="screen_li" v-show="screen_active === '全部' || screen_active === '成立时间'">
                  <div class="screen_tle" @click="screenTle.time = !screenTle.time">
                    <span>成立时间</span>
                    <Icon type="md-add" v-if="!screenTle.time" />
                    <Icon type="md-remove" v-else />
                  </div>
                  <div class="screen_cnt" v-show="screenTle.time">
                    <RadioGroup v-model="selTime" vertical @on-change="handleChangeTime">
                      <Radio label=""><span>不限</span></Radio>
                      <Radio v-for="(item, index) in timeOption" :label="item" :key="index">
                        <span>{{item}}({{item | dealName(yearNum, 'year', 'num', '0')}})</span>
                      </Radio>
                      <Radio label="zdy"><span>自定义</span></Radio>
                    </RadioGroup>
                    <div class="zdy_time" v-if="selTime == 'zdy'">
                      <DatePicker type="date" v-model="params.s_time" placeholder="开始时间" :options="startOptions" @on-change="getEntityList" :clearable="false"></DatePicker>
                      <DatePicker type="date" v-model="params.e_time" placeholder="结束时间" :options="endOptions" @on-change="getEntityList" :clearable="false"></DatePicker>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Sider>
        <Content>
          <div class="top-tip">全部<span v-if="!listLoading">（{{total}}）</span>
            <Dropdown @on-click="haddleChangeSort">
              <a href="javascript:void(0)">{{sort_id | dealName(sort_list)}}<i class="iconfont">&#xe6ea;</i></a>
              <DropdownMenu slot="list">
                <DropdownItem v-for="item in sort_list" :key="item.id" :name="item.id" :disabled="sort_id === item.id">{{item.name}}</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <div class="sel_opt" v-if="haveOption && haveOption.length > 0">
            <div class="sel_tle">已选条件</div>
            <div class="sel_cnt">
              <span v-for="(item,index) in haveOption" :key="index" @click="handleCancelOption(item)">{{item.name}}
                <Icon type="md-close" />
              </span>
            </div>
            <div class="sel_clear">
              <span @click="handleClearOption"><i class="iconfont">&#xe63e;</i>清空筛选</span>
            </div>
          </div>
          <div class="list_div">
            <Table :columns="listColumns" :data="listData" :row-class-name="rowClassName">
              <template slot-scope="{ row }" slot="company_name">
                <div class="company">
                  <div class="logo_img" @click="goEntityDetail(row.uid, 0)">
                    <img :src="row.logo_path | logo_show">
                  </div>
                  <div class="company_name">
                    <p><a @click="goEntityDetail(row.uid, 0)">{{row.short_name}}</a></p>
                  </div>
                </div>
                <div class="supply-demand-list" v-if="row.entity_links.length">
                  <div v-for="(demand, dindex) in row.entity_links" :key="dindex" :class="['demand-item', demand.type == 1 && 'green']" @click="goLinkDetail(demand.id)">
                    <i class="iconfont-pc30">&#xe6de;</i>
                    <div class="tag">{{demand.type == 1 ? '需求' : '供给'}}已验证</div>
                    <div class="link-title">{{demand.title}}</div>
                  </div>
                </div>
              </template>
            </Table>
            <SearchPrompt v-if="haveOption && haveOption.length > 0 && !isVIP  && listData.length == 5 && total > 5"></SearchPrompt>
            <template v-else>
              <div class="page clear" v-if="total > 10">
                <Page :current="params.page" :total="total" :page-size="10" class="page_list" show-total show-elevator ref="pages" @on-change="handleChangePage" />
              </div>
            </template>
            <Spin fix v-if="listLoading">
              <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
              <div>Loading</div>
            </Spin>
          </div>
        </Content>
      </Layout>
    </div>
  </div>
</template>

<script>
import { compList, compNum, tagCompNum } from '../../service'
import { idxOf, remove, removeArrObj } from 'js/findIndex'
import { listMixins } from 'js/listMixins'
import { userInfo } from 'js/userInfo'
import Nothing from '@/components/Nothing.vue'
import DataNavigation from './components/DataNavigation.vue'
import VipPrompt from '@/components/VipPrompt.vue'
import EntityAttention from './components/EntityAttention.vue'
import SearchPrompt from './components/SearchPrompt.vue'
import filter from 'js/filter'
import moment from 'moment'

export default {
  inject: ['login'],
  mixins: [listMixins, userInfo],
  components: {
    Nothing,
    DataNavigation,
    VipPrompt,
    EntityAttention,
    SearchPrompt,
  },
  data() {
    return {
      listName: '公司',
      listColumns: [
        {
          title: '公司名称',
          width: 190,
          slot: 'company_name',
        },
        {
          title: '简要介绍',
          width: 210,
          render: (h, params) => {
            return h('div', {
              class: {
                'dec-clamp': true
              }
            }, filter.empty(params.row.description))
          }
        },
        {
          title: '地区',
          width: 100,
          render: (h, params) => {
            return h('span', filter.addressDeal(params.row.address_id, '2'))
          }
        },
        {
          title: '当前轮次',
          width: 80,
          render: (h, params) => {
            return h('span', filter.deal(params.row.round_id, 'round'))
          }
        },
        {
          title: '成立时间',
          width: 90,
          render: (h, params) => {
            return h('span', filter.timeTrans(params.row.setup_time))
          }
        },
        {
          title: '最新融资金额',
          width: 120,
          render: (h, params) => {
            return h('span', filter.amountPrecise(
              params.row.latest_event.amount,
              params.row.latest_event.unit_id,
              params.row.latest_event.precise
            ))
          }
        },
        {
          title: '投资方',
          minWidth: 110,
          render: (h, params) => {
            if (params.row.latest_event.tzf_arr && params.row.latest_event.tzf_arr.length > 0) {
              let tzf = []
              params.row.latest_event.tzf_arr.map((a, index) => {
                if (a.entity_type != '2') {
                  tzf.push(h('a', {
                    on: {
                      click: () => {
                        this.goEntityDetail(a.entity_uid, a.entity_type)
                      }
                    }
                  }, a.short_name))
                } else {
                  tzf.push(h('span', a.name))
                }
                if (index < params.row.latest_event.tzf_arr.length - 1) tzf.push(h('span', '、'))
              })
              return h('div', {
                class: {
                  'dec-clamp': true
                }
              }, tzf)
            } else {
              return h('span', '未透露')
            }
          }
        },
        {
          title: '操作',
          align: 'center',
          width: 70,
          render: (h, params) => {
            return h('div', [
              h(EntityAttention, {
                props: {
                  entityItem: params.row,
                  entityType: '0'
                }
              }, [
                h('span', {
                  class: {
                    'li-att': true
                  },
                  slot: 'slot1'
                }, '关注'),
                h('span', {
                  class: {
                    'li-att on': true
                  },
                  slot: 'slot2'
                }, '已关注')
              ])
            ])
          }
        }
      ],
      params: {
        round_id: [],
        demostic: null,
        address_id: [],
        year: '',
        s_time: '',
        e_time: '',
        user_key: '',
        tag_arr: [],
        keyword: '',
        page: 1,
        sort_type: 0,
      },
      screen_dropdown: ['全部', '公司领域', '融资轮次', '地区选择', '成立时间'],
      //筛选条件是否展开
      screenTle: {
        tag_arr: false,
        round_id: false,
        address: false,
        time: false,
      },
      //融资轮次 相关变量
      //不限
      checkAll: {
        tag_arr: true,
        round_id: true,
        address_id: true,
      },
      showAllRound: false,
      showAllTag: false,

      chinaNum: 0,
      foreignNum: 0,
      provinceNum: [],
      roundNum: [],
      yearNum: [],
      tagNum: [],
      sort_id: 4,
      sort_list: [
        // {id: 0, name: '默认排序'},
        { id: 4, name: '最新融资时间倒序' },
        { id: 3, name: '最新融资时间正序' },
        { id: 2, name: '成立时间倒序' },
        { id: 1, name: '成立时间正序' },
      ],
      position_id: '10',
    }
  },
  computed: {
    round() {
      return this.$store.state.round
    },
    haveOption() {
      let optionRound = [],
        optionTag = [],
        optionYear = [],
        optionStart = [],
        opitonEnd = [],
        optionAddressId = [],
        optionKeyWord = [],
        optionDemostic = []

      this.params.tag_arr.map((a) => {
        optionTag.push({
          type: 'tag_arr',
          name: this.hot_tag_map.length ? filter.dealName(a, this.hot_tag_map) : '--',
          value: a,
        })
      })
      this.params.round_id.map((a) => {
        optionRound.push({
          type: 'round_id',
          name: filter.deal(a, 'round'),
          value: a,
        })
      })
      if (this.params.year != '' && this.selTime != 'zdy') {
        optionYear = {
          type: 'year',
          name: this.params.year,
          value: this.params.year,
        }
      }
      if (this.params.s_time != '') {
        optionStart = {
          type: 's_time',
          name: '开始时间：' + filter.time_moment(this.params.s_time),
          value: this.params.s_time,
        }
      }
      if (this.params.e_time != '') {
        opitonEnd = {
          type: 'e_time',
          name: '结束时间：' + filter.time_moment(this.params.e_time),
          value: this.params.e_time,
        }
      }
      if (this.params.demostic !== null) {
        optionDemostic = {
          type: 'demostic',
          name: this.params.demostic == 0 ? '国外' : '国内',
          value: this.params.demostic,
        }
      }
      if (this.params.keyword !== '') {
        optionKeyWord = {
          type: 'keyword',
          name: this.params.keyword,
          value: this.params.keyword,
        }
      }
      this.params.address_id.map((a) => {
        optionAddressId.push({
          type: 'address_id',
          name: filter.deal(a, 'address'),
          value: a,
        })
      })

      return [].concat(
        optionTag,
        optionRound,
        optionYear,
        optionStart,
        opitonEnd,
        optionDemostic,
        optionKeyWord,
        optionAddressId
      )
    },
  },
  methods: {
    /**
     * 获取公司列表
     */
    async getEntityList() {
      this.params.sort_type = this.sort_id
      this.params.user_key = this.user_key
      if (this.params.s_time) {
        this.params.s_time = moment(this.params.s_time).format('YYYY-MM-DD')
      }
      if (this.params.e_time) {
        this.params.e_time = moment(this.params.e_time).format('YYYY-MM-DD')
      }
      this.listLoading = true
      let res = await compList(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'listData', res.res)
        if (this.params.page == 1) {
          this.$set(this.$data, 'total', res.count)
        }
        this.listLoading = false
      } else {
        this.$Message.error(res.message)
      }
    },
    /**
     * 清空已选择项
     */
    handleClearOption() {
      this.params = {
        tag_arr: [],
        round_id: [],
        demostic: null,
        address_id: [],
        year: '',
        user_key: '',
        keyword: '',
        s_time: '',
        e_time: '',
      }
      ;(this.checkAll = {
        tag_arr: true,
        round_id: true,
        address_id: true,
      }),
        (this.checkAllRound = true)
      this.selTime = ''
      this.search_ipt = ''
      this.params.page = 1
      this.getEntityList()
    },
    /**
     * 筛选个数
     */
    async getCount() {
      let res = await compNum((error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'chinaNum', res.china)
        this.$set(this.$data, 'foreignNum', res.foreign)
        this.$set(this.$data, 'provinceNum', res.province)
        this.$set(this.$data, 'roundNum', res.round)
        this.$set(this.$data, 'yearNum', res.year)
      } else {
        this.$Message.error(res.message)
      }
    },
    /**
     * 产业领域数量计算-公司
     */
    async getTagNum(t_arr) {
      let res = await tagCompNum(
        {
          tag_arr: t_arr,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      if (res.status == 'success') {
        this.$set(this.$data, 'tagNum', res.res)
      } else {
        this.$Message.error(res.message)
      }
    }
  },
  created() {
    if (this.$store.state.comp_params != '') {
      this.params = { ...this.$store.state.comp_params }
      this.params.page = 1
      this.sort_id = this.params.sort_type
    }
    if (this.$route.query.keyword) {
      this.params.keyword = this.$route.query.keyword
      this.search_ipt = this.$route.query.keyword
      this.$router.replace({ name: 'CompanyList' })
    }
    this.getMeta()
    this.getEntityList()
    this.getCount()
  },
  mounted() {
    this.$nextTick(() => {
      window.onscroll = () => {
        this.listenerScroll('right_column', 10)
      }
      window.onresize = () => {
        this.listenerScroll('right_column', 10)
      }
    })
  },
  destroyed() {
    window.onscroll = ''
    window.onresize = ''
  },
  beforeDestroy() {
    this.$store.commit('updateCompParams', this.params)
  },
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/dataList.stylus'
</style>
